import * as React from "react";

import styles from "./Card.module.css";

export interface CardProps {
  children: React.ReactNode;
  className?: string;
}

/** White rounded panel — the base surface used across the document card page. */
export const Card = React.forwardRef<HTMLDivElement, CardProps>(({ children, className }, ref) => (
  <div ref={ref} className={`${styles.card}${className ? ` ${className}` : ``}`}>
    {children}
  </div>
));

Card.displayName = 'Card';
